<script setup lang="ts">
import { RouterLink, useRoute } from 'vue-router'
import AppNavIcon from '@/components/AppNavIcon.vue'

defineProps<{ mobile?: boolean }>()
const route = useRoute()
const entries = [
  { to: '/market', label: '行情', icon: 'market' },
  { to: '/trade', label: '交易', icon: 'trade' },
  { to: '/portfolio', label: '資產', icon: 'wallet' },
  { to: '/user-center', label: '用戶中心', icon: 'user' },
] as const
function isActive(to: string) {
  if (to === '/user-center') return ['/user-center', '/profile', '/orders', '/identity-verification', '/bank-account'].some(path => route.path === path) || route.path === '/announcements' || route.path.startsWith('/announcements/')
  return route.path === to || route.path.startsWith(`${to}/`)
}
</script>

<template>
  <nav class="app-navigation" :class="{ 'app-navigation--mobile': mobile }" :aria-label="mobile ? '底部導覽' : '主要導覽'">
    <RouterLink v-for="entry in entries" :key="entry.to" :to="entry.to" :class="{ 'is-current': isActive(entry.to) }" :aria-current="isActive(entry.to) ? 'page' : undefined">
      <span class="app-navigation__icon"><AppNavIcon :name="entry.icon" /></span><span>{{ entry.label }}</span>
    </RouterLink>
  </nav>
</template>

<style scoped>
.app-navigation { display: flex; height: 100%; align-items: center; gap: 6px; }
.app-navigation a { position: relative; display: flex; min-height: 44px; align-items: center; gap: 9px; padding: 0 15px; border-radius: 11px; color: var(--muted); font-size: .8rem; font-weight: 650; transition: color .18s, background .18s; }
.app-navigation a:hover { color: var(--text); background: rgba(255,255,255,.035); }
.app-navigation a:focus-visible { outline: 2px solid var(--focus-ring); outline-offset: 3px; }
.app-navigation a.is-current { background: var(--accent-soft); color: var(--accent); }
.app-navigation__icon { display: grid; width: 22px; height: 24px; place-items: center; }
.app-navigation__icon svg { width: 21px; height: 21px; }
.app-navigation--mobile { display: none; }
@media (max-width: 1080px) and (min-width: 901px) { .app-navigation a { padding-inline: 11px; } .app-navigation__icon { display: none; } }
@media (max-width: 900px) {
  .app-navigation { display: none; }
  .app-navigation--mobile { position: fixed; z-index: 40; right: 0; bottom: 0; left: 0; display: grid; height: auto; min-height: 72px; grid-template-columns: repeat(4, minmax(0, 1fr)); align-items: stretch; gap: 8px; padding: 5px 12px max(7px, env(safe-area-inset-bottom)); border-top: 1px solid rgba(147,182,205,.19); background: rgba(9,21,32,.97); box-shadow: 0 -8px 30px rgba(1,8,16,.16); backdrop-filter: blur(20px); }
  .app-navigation--mobile a { min-width: 0; min-height: 59px; justify-content: center; flex-direction: column; gap: 3px; padding: 4px 0; border-radius: 10px; color: #a7baca; font-size: 11px; font-weight: 600; line-height: 1.4; }
  .app-navigation--mobile a.is-current { background: transparent; color: #6febd0; }
  .app-navigation--mobile .app-navigation__icon { width: 45px; height: 30px; border-radius: 10px; transition: background .18s; }
  .app-navigation--mobile .app-navigation__icon svg { width: 24px; height: 24px; }
  .app-navigation--mobile a.is-current .app-navigation__icon { background: rgba(91,224,198,.11); box-shadow: inset 0 0 0 1px rgba(91,224,198,.12); }
}
</style>
